import { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import ErrorMessage from './shared/ErrorMessage';

type ErrorBoundaryProps = {
  children?: ReactNode;
};

type State = {
  error: Error | null;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error });
    Sentry.captureException(error, {
      extra: { ...errorInfo },
    });
  }

  render() {
    if (this.state.error) {
      return <ErrorMessage statusCode={0} />;
    }

    // When there's not an error, render children untouched
    return this.props.children;
  }
}

export default ErrorBoundary;
